import React from "react";
import { Box, Typography, Paper } from "@mui/material";
import { useAuth } from "../hooks/useAuth";

const Profile = () => {
  const { fullName, username, email, roles } = useAuth();

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" gutterBottom>
        My Profile
      </Typography>

      <Paper sx={{ p: 3 }}>
        <Typography variant="subtitle1"><strong>Full Name:</strong> {fullName}</Typography>
        <Typography variant="subtitle1"><strong>Username:</strong> {username}</Typography>
        <Typography variant="subtitle1"><strong>Email:</strong> {email}</Typography>
        <Typography variant="subtitle1"><strong>Roles:</strong> {roles.join(", ")}</Typography>
      </Paper>
    </Box>
  );
};

export default Profile;
